<template>
  <div>
    <div class="control push-up">
      <div class="row">
        <div class="small-12 columns">
          <h-3-and-tooltip
            :h3="sellersInsuranceModel.Label_WhyBuyingHouseInsurance"
            :tooltip="sellersInsuranceModel.Tooltip_WhyBuyingHouseInsurance"
          />
        </div>
      </div>
      <div class="row">
        <div class="small-12 columns">
          <div class="radio-stacked">
            <Field
              :id="'radio1'"
              v-model="vueModel.AdditionalInformation.HasInsurance"
              :rules="{ required_notnull: vueModel.AdditionalInformation.HasInsurance === null }"
              type="radio"
              name="InsuranceReason"
              :value="false"
              :label="decodeHtml(sellersInsuranceModel.FieldName_WhyBuyingHouseInsurance)"
            />
            <label for="radio1" v-html="sellersInsuranceModel.LabelBuyHouse" />
          </div>
          <div class="radio-stacked">
            <Field
              :id="'radio2'"
              v-model="vueModel.AdditionalInformation.HasInsurance"
              type="radio"
              :value="true"
              :label="decodeHtml(sellersInsuranceModel.FieldName_WhyBuyingHouseInsurance)"
              :rules="{ required: vueModel.AdditionalInformation.HasInsurance === null }"
              name="InsuranceReason"
            />
            <label for="radio2" v-html="sellersInsuranceModel.LabelChangeInsuranceCompany" />
          </div>
        </div>
        <div class="small-12 columns">
          <ValidationError name="InsuranceReason" />
        </div>
      </div>
    </div>

    <div v-if="vueModel.AdditionalInformation.HasInsurance === false">
      <div id="StartDate" class="control push-up">
        <div class="row">
          <div class="small-12 columns">
            <h-3-and-tooltip
              :h3="sellersInsuranceModel.Label_GetKeysFromNewHouse"
              :tooltip="sellersInsuranceModel.Tooltip_GetKeysFromNewHouse"
            />
          </div>
        </div>
        <div class="row">
          <div class="small-12 columns">
            <p v-html="sellersInsuranceModel.Description_GetKeysFromNewHouse" />
          </div>
        </div>
        <div class="row">
          <div class="small-12 medium-6 columns">
            <Field
              v-slot="{ field }"
              name="startdate"
              :label="decodeHtml(sellersInsuranceModel.FieldName_GetKeysFromNewHouse)"
              :model-value="vueModel.AdditionalInformation.StartDate"
              :rules="{ required: true }"
            >
              <date-picker
                id="startdate"
                :name="field.name"
                :min-date="currentDate"
                :model-value="vueModel.AdditionalInformation.StartDate"
                class="datepicker"
                :placeholder="sellersInsuranceModel.SharedContent.PlaceholderSelectDate"
                :label="decodeHtml(sellersInsuranceModel.FieldName_GetKeysFromNewHouse)"
                @update:model-value="dateChanged"
              />
            </Field>
          </div>
        </div>
        <div class="row">
          <div class="small-12 medium-6 columns">
            <ValidationError name="startdate" data-test-base-validation-error="StartDate" />
          </div>
        </div>
      </div>

      <div class="control push-up">
        <div class="row">
          <div class="small-12 columns">
            <h-3-and-tooltip
              :h3="sellersInsuranceModel.Label_SellersInsuranceCompany"
              :tooltip="sellersInsuranceModel.Tooltip_SellersInsuranceCompany"
            />
          </div>
        </div>
        <div class="row">
          <div class="small-6 columns">
            <div class="radio-stacked">
              <Field
                id="radio3"
                v-model="vueModel.AdditionalInformation.IsSellersInsuranceAvailable"
                :rules="{
                  required_notnull: vueModel.AdditionalInformation.IsSellersInsuranceAvailable === null
                }"
                type="radio"
                name="IsSellersInsuranceAvailable"
                :value="false"
                :label="decodeHtml(sellersInsuranceModel.FieldName_SellersInsuranceCompany)"
              />
              <label for="radio3" v-html="sellersInsuranceModel.SharedContent.LabelYes" />
            </div>
          </div>
          <div class="small-6 columns">
            <div class="radio-stacked">
              <Field
                id="radio4"
                v-model="vueModel.AdditionalInformation.IsSellersInsuranceAvailable"
                :rules="{
                  required_notnull: vueModel.AdditionalInformation.IsSellersInsuranceAvailable === null
                }"
                type="radio"
                :value="true"
                name="IsSellersInsuranceAvailable"
                :label="decodeHtml(sellersInsuranceModel.FieldName_SellersInsuranceCompany)"
              />
              <label for="radio4" v-html="sellersInsuranceModel.SharedContent.LabelNo" />
            </div>
          </div>
          <div class="small-12 columns">
            <ValidationError name="IsSellersInsuranceAvailable" />
          </div>
        </div>
      </div>
      <div v-if="vueModel.AdditionalInformation.IsSellersInsuranceAvailable == true">
        <div class="control push-up">
          <div class="row">
            <div class="small-12 columns">
              <h-3-and-tooltip
                :h3="sellersInsuranceModel.Label_NewHouseQuestionsAboutPreviousOwner"
                :tooltip="sellersInsuranceModel.Tooltip_NewHouseQuestionsAboutPreviousOwner"
              />
            </div>
          </div>
          <div class="row">
            <div class="small-12 columns">
              <p v-html="sellersInsuranceModel.Description_NewHouseQuestionsAboutPreviousOwner" />
            </div>
          </div>
          <div class="row">
            <div class="small-12 columns">
              <p class="text-question">
                <LabelAndTooltip
                  :label="sellersInsuranceModel.Label_NewHouseCurrentInsuranceCompany"
                  :tooltip="sellersInsuranceModel.Tooltip_NewHouseCurrentInsuranceCompany"
                />
              </p>
            </div>
          </div>
          <div class="row">
            <div class="small-12 medium-6 columns">
              <Field
                v-model="vueModel.AdditionalInformation.SellersInsuranceCompany"
                :rules="'required: vueModel.AdditionalInformation.SellersInsuranceCompany === null'"
                name="CurrentInsuranceCompany"
                v-slot="{ field }"
                :label="decodeHtml(sellersInsuranceModel.FieldName_NewHouseCurrentInsuranceCompany)"
              >
                <VueSelect
                  class="v-select-search-icon"
                  v-bind="field"
                  :model-value="field.value"
                  :options="vueModel.AdditionalInformation.TakeoverInformation.InsuranceCompanies"
                  label="Name"
                  :placeholder="sellersInsuranceModel.SharedContent.PlaceholderSelect"
                />
              </Field>
            </div>
          </div>
          <div class="row">
            <div class="small-12 medium-6 columns">
              <ValidationError name="CurrentInsuranceCompany" />
            </div>
          </div>
        </div>

        <div class="control">
          <div class="row">
            <div class="small-12 columns">
              <p class="text-question">
                <LabelAndTooltip
                  :label="sellersInsuranceModel.Label_NewHousePolicyNumber"
                  :tooltip="sellersInsuranceModel.Tooltip_NewHousePolicyNumber"
                />
              </p>
            </div>
          </div>
          <div class="row">
            <div class="small-12 medium-6 columns">
              <Field
                name="PolicyNumber"
                :rules="'required|letters_numbers'"
                type="text"
                v-model="vueModel.AdditionalInformation.SellersPolicyNumber"
                :label="decodeHtml(sellersInsuranceModel.FieldName_NewHousePolicyNumber)"
              />
            </div>
          </div>
          <div class="row">
            <div class="small-12 medium-6 columns">
              <ValidationError name="PolicyNumber" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import H3AndTooltip from '@/components/UI/H3AndTooltip.vue';
import Utility from '@/common/UtilityFunctions.js';
import ValidationError from '@/components/UI/ValidationError.vue';
import pickadate from '@/components/UI/Pickadate.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SellersInsurance',
  components: {
    'date-picker': pickadate,
    H3AndTooltip,
    ValidationError
  },
  props: {
    externalVueModel: {
      type: Object,
      default() {
        return null;
      }
    },
    externalSellersInsuranceModel: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      vueModel: this.externalVueModel,
      sellersInsuranceModel: this.externalSellersInsuranceModel,
      currentDate: new Date()
    };
  },
  watch: {
    vueModel: {
      handler() {
        this.$emit('sellers-insurance-updated', this.vueModel);
      },
      deep: true
    }
  },
  methods: {
    decodeHtml: Utility.decodeHtml,
    dateChanged(param) {
      this.vueModel.AdditionalInformation.StartDate = param;
    }
  }
});
</script>
